"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualUserApi = void 0;
var api_client_1 = __importDefault(require("../api-client"));
var virtualuser_constans_1 = require("./virtualuser.constans");
var VirtualUserApi = /** @class */ (function () {
    function VirtualUserApi() {
    }
    VirtualUserApi.addVirtualUser = function (data) {
        return api_client_1.default.post(virtualuser_constans_1.VIRTUAL_USER_API_URLS.ADD_VIRTUAL_USER, data);
    };
    return VirtualUserApi;
}());
exports.VirtualUserApi = VirtualUserApi;
